import React from 'react';
import { Square, Squish } from '@grubhubprod/gh-cookbook-react';

export type GroupLocTableItemContainerProps = {
  isPhone: boolean;
};

export const GroupLocTableItemContainer: React.FC<GroupLocTableItemContainerProps> =
  ({ children, isPhone }) => {
    if (isPhone) {
      return (
        <Square
          as="li"
          inset="md"
          borderBottom="1px solid"
          borderColor="lightLine"
        >
          {children}
        </Square>
      );
    }

    return (
      <Squish
        as="li"
        inset="lg"
        borderBottom="1px solid"
        borderColor="lightLine"
      >
        {children}
      </Squish>
    );
  };
